module.exports = '4.15.0';



// WEBPACK FOOTER //
// ./src/version.js